import script from "./CajaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CajaView.vue?vue&type=script&setup=true&lang=js"

import "./CajaView.vue?vue&type=style&index=0&id=3b02c219&scoped=true&lang=css"
import "./CajaView.vue?vue&type=style&index=1&id=3b02c219&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b02c219"]])

export default __exports__